<template>
  <v-card elevation="0">
    <v-card-title class="pl-0"
      ><v-btn
        @click="$router.back()"
        color="secondaryAction"
        height="4em"
        class="rounded-lg pa-0 mr-4"
        ><v-icon color="white">mdi-chevron-left</v-icon></v-btn
      >
      {{ $t("register.profileInfo") }}</v-card-title
    >
    <v-form @submit="proceedIfValid" onSubmit="return false;">
      <v-row align="center">
        <v-col cols="8"
          ><v-text-field
            v-model="username"
            outlined
            label="Username"
            prepend-icon="mdi-at"
            :rules="[
              () => !!username || $t('forms.thisFieldIsRequired'),
              () =>
                username.length >= MIN_USERNAME_CHARS ||
                $t('register.usernameSize'),
              () =>
                username.length <= MAX_USERNAME_CHARS ||
                $t('register.usernameSize'),
            ]"
            :loading="loading"
            :error-messages="usernameErrors"
        /></v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-row justify="center">
            <v-avatar size="120" v-if="imageUrl != ''">
              <img :src="imageUrl" />
            </v-avatar>
            <v-icon size="120" v-else>mdi-account-circle</v-icon>
          </v-row>
          <v-row class="mt-7" justify="center">
            <MediaObjectUpload
              v-model="imageUrl"
              :requirements="{ minHeight: 300, minWidth: 300}"
              :addText="$t('chapter.image.addImage')"
              :changeText="$t('chapter.image.changeImage')"
              @error="addImageErrorMessage"
              @loading="imageUploading = $event"
              @newId="newMediaId"
              :errorTooLargeMessage="
                $t('register.imageTooLarge', {
                  maxImageSize: MAX_IMAGE_SIZE_MB,
                })
              "
              :maxSizeBytes="MAX_IMAGE_SIZE_BYTES"
              :formats="IMAGE_FORMATS"
            />
          </v-row>
          <v-row>
            <v-col class="text-center" cols="12">
              <span class="error-text">{{ imageErrorMessage }}</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="mt-9">
        <v-col>
          <v-btn tabindex="4" block type="submit" color="primary">{{
            $t("register.next")
          }}</v-btn>
        </v-col>
      </v-row>
    </v-form>
    <v-snackbar v-model="imageUploading" right timeout="-1">
      <h3> {{ $t('forms.uploading') }} </h3>
      <v-progress-linear
        indeterminate
        class="mt-3"
        color="primaryAction darken-2"
      ></v-progress-linear>
    </v-snackbar>
  </v-card>
</template>
<script>
import debounce from "@/helpers/debounce";
import { mapMutations } from "vuex";
import { USER_EXISTS } from "@/graphql/UserQueries";
import MediaObjectUpload from "@/components/MediaObjectUpload";
import { IMAGE_FORMATS } from "@/const";
const MAX_USERNAME_CHARS = 24;
const MIN_USERNAME_CHARS = 4;
const MAX_IMAGE_SIZE_MB = 5;
const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;
export default {
  components: {
    MediaObjectUpload,
  },
  data() {
    return {
      username: "",
      queryUsername: "",
      queryAllowed: false,
      imageUrl: "",
      temp: true,
      imageErrorMessage: null,
      imageUploading: false,
    };
  },
  apollo: {
    usernameExists: {
      query: USER_EXISTS,
      fetchPolicy: "network-only",
      variables() {
        return {
          username: this.queryUsername,
        };
      },
      update(data) {
        return data.existsUser != null;
      },
      skip() {
        return !this.queryAllowed;
      },
    },
  },
  methods: {
    ...mapMutations("auth/registration", ["setUsername", "setProfileImageId"]),
    newMediaId(id) { this.setProfileImageId(id); },
    addImageErrorMessage(message) {
      this.imageErrorMessage = message;
    },
    proceedIfValid() {
      if (this.valid) {
        this.setUsername(this.username)
        this.$router.push("/auth/register/eula");
      }
    },
  },
  watch: {
    username: debounce(function (newValue) {
      if (
        this.username.length >= MIN_USERNAME_CHARS &&
        this.username.length <= MAX_USERNAME_CHARS
      ) {
        this.queryAllowed = true;
        this.queryUsername = newValue;
      } else {
        this.queryAllowed = false;
      }
    }, 500),
    imageUrl() {
      this.imageErrorMessage = null;
    },
  },
  computed: {
    MIN_USERNAME_CHARS() {
      return MIN_USERNAME_CHARS;
    },
    MAX_USERNAME_CHARS() {
      return MAX_USERNAME_CHARS;
    },
    MAX_IMAGE_SIZE_BYTES() {
      return MAX_IMAGE_SIZE_BYTES;
    },
    MAX_IMAGE_SIZE_MB() {
      return MAX_IMAGE_SIZE_MB;
    },
    IMAGE_FORMATS() {
      return IMAGE_FORMATS;
    },
    loading() {
      return this.$apollo.queries.usernameExists.loading;
    },
    usernameErrors() {
      if (this.usernameExists) {
        return this.$t("register.usernameInUse");
      }
      return null;
    },
    valid() {
      return (
        !this.usernameExists &&
        this.username.length >= MIN_USERNAME_CHARS &&
        this.username.length <= MAX_USERNAME_CHARS &&
        !this.loading
      );
    },
  },
};
</script>
<style  scoped>
::v-deep img {
  object-fit: cover;
}
.error-text {
  color: var(--v-error-base);
}
</style>